import type App from "byzantine/src/App";
import { useUserFeatures } from "../contexts/UserFeaturesContext";

const useIsServicesEnabled = (services: App[] | undefined): boolean => {
  const { aoiob } = useUserFeatures();
  return (services?.length ?? 0) > 0 || Boolean(aoiob);
};

export default useIsServicesEnabled;
